"use client";

import CheckIfTrial from "@/components/CheckIfTrial";
import CreateRecipe from "@/components/CreateRecipe";

const createRecipe = () => {
  return (
    <CheckIfTrial>
      <CreateRecipe />
    </CheckIfTrial>
  );
};

export default createRecipe;
